var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgProperties = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 48,
    height: 48,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,238,242)",
    fillRule: "evenodd",
    d: "M3 23.1085515c0 11.1050136 9.00284965 20.1076647 20.1081081 20.1076647 11.1052585 0 20.1081081-9.0026511 20.1081081-20.1076647 0-11.10501364-9.0019629-20.1067781-20.1072214-20.1076648V3H3.00088672S3 23.095251 3 23.1085515"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(216,241,236)",
    fillRule: "evenodd",
    d: "M26.5 17l5.5-5 14 13v19.06075152h-8.47136824C35.73669004 44.06075152 38.18156381 32.49750466 36.5 31.5c-2.1321071-1.26476722-8.10991164-.18198765-9.16021082-.58431617-.62942598-.24110846.04465669 13.06372475.04465669 13.06372475.03994215.01997107-9.38444587.08134294-9.34051921.05923091.06586723-.0331566 0-19.03863949 0-19.03863949L26.5 17z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 13,
    x: 27,
    y: 31,
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(10,20,40)",
    fillRule: "evenodd",
    d: "M16.6875 25.0836258c0-.24652482.10399246-.48160935.28640366-.64744187L31.41140747 11.3108921c.33374024-.30341149.84344482-.30341149 1.17718506 0l14.4375 13.12529182c.18241882.16583252.28640747.40091705.28640747.64744186v18.95804406c0 .48324585-.39175415.875-.875.875h-28.875c-.48324966 0-.875-.39175415-.875-.875V25.08362579zm21 18.08303642h7.875V25.47069168L32 13.14087296 18.4375 25.47069168v17.69597054h7.875V31.20833206c0-.48324776.39175415-.875.875-.875h9.625c.48324585 0 .875.39175224.875.875v11.95833016zm-9.625 0V32.08333206h7.875v11.08333016h-7.875z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProperties, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/properties.d5d64f87.svg";
export { ForwardRef as ReactComponent };